import { gsmIotDeviceList, gsmIotDeviceDetail, extendedServerToken } from "../constants/apis";
import axios from "axios";
 
const getIotConfig = () => ({
    headers: {
        "Content-Type": "application/json",
        "Authorization": `Token ${extendedServerToken}`,
    },
});
 
export const getIotDevices = async (query = "") => {
    const response = await axios.get(`${gsmIotDeviceList}${query}`, getIotConfig());
    return response;
};
 
export const getIotDeviceDetails = async (deviceId) => {
    const response = await axios.get(`${gsmIotDeviceDetail}${deviceId}/`, getIotConfig());
    return response;
};
 
export const getIotDeviceStats = async () => {
    const response = await axios.get(
        `${gsmIotDeviceList.replace("gsm-list/", "gsmiot-stats")}`,
        getIotConfig()
    );
    return response;
};
